import {
  Attribute,
  AttributeGroup,
  AttributeProperty,
  ButtonStateAttributes,
  ComponentProps,
  ConfigsProvider,
  ContainerAttributes,
} from "react-builder";
import styled from "styled-components";
import { ResetPasswordForm } from "../components/ResetPasswordForm";

@AttributeGroup({
  title: "ChangePasswordWidget",
  blockName: "ChangePasswordWidget",
  icon: "query",
})
export class ChangePasswordWidgetAttributes extends Attribute {
  @AttributeProperty({ type: "Object", cssTarget: "" })
  container: ContainerAttributes = new ContainerAttributes();
  @AttributeProperty({ title: "Inner Box", type: "Object", cssTarget: " .login-form" })
  innerBox: ContainerAttributes = new ContainerAttributes();
  @AttributeProperty({ type: "Object", cssTarget: " button.submit-button" })
  button: ButtonStateAttributes = new ButtonStateAttributes();
  @AttributeProperty({ title: "Input", type: "Object", cssTarget: " input" })
  inputContainer: ContainerAttributes = new ContainerAttributes();
}

const ChangePasswordWidgetTheme = styled.div(
  (props: { attributes: ChangePasswordWidgetAttributes }) => `
  
      ${props.attributes.toCSS()}
  
  `
);

export function ChangePasswordWidget(props: ComponentProps<ChangePasswordWidgetAttributes>) {
  return (
    <ChangePasswordWidgetTheme {...props} attributes={props.attributes}>
      <ResetPasswordForm></ResetPasswordForm>
      {props.children}
    </ChangePasswordWidgetTheme>
  );
}

ChangePasswordWidget.prototype.Props = ChangePasswordWidgetAttributes;

export default ChangePasswordWidget;
